//
// Interaction.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./InteractionType";
import "./DataStage";
import "../visualElements/actions/AbstractAction";
import "./InteractionElementReference";

var Interaction = createModule("BIRD::Interaction", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        name: 7,
        action: 1,
        dataStage: 4,
        source: 1,
        type: 4,
        derived: 2,
        target: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Interaction;
